import React, { useState } from "react";
import ReactDOM from "react-dom";
import { NavLink, Link } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import DropdownToggle from "react-bootstrap/DropdownToggle";
import DropdownMenu from "react-bootstrap/DropdownMenu";
import DropdownItem from "react-bootstrap/DropdownItem";
import { Nav, Navbar, NavDropdown } from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "../../css/app.css";
import MainLogo from "./images/logos/logo-12.png";
import DefaultLogo from "./images/default-img.jpg";

// Menu Icons
import ViewProfile from "./images/menu-icons/user.png";
import MySettings from "./images/menu-icons/settings.png";
import CreatorSettings from "./images/menu-icons/creator-settings.png";
import Performance from "./images/menu-icons/performance.png";
import Followers from "./images/menu-icons/followers.png";
import Following from "./images/menu-icons/following.png";
import MyRefferals from "./images/menu-icons/my-referrals.png";
import AddAccount from "./images/menu-icons/add-account.png";
import AddCard from "./images/menu-icons/add-card.png";
import DarkMode from "./images/menu-icons/dark-mode.png";
import LightMode from "./images/menu-icons/light-icon.png";
import HelpFaq from "./images/menu-icons/help-faqs.png";
import Logout from "./images/menu-icons/logout.png";

class Header extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const isLoggedIn = localStorage.getItem("loggedin_user");
        // if(isLoggedIn)
        // return <Redirect to="/chat"/>;
        const darkmode = localStorage.getItem("darkmode");

        if (darkmode === "true") {
            document.body.classList.add("darkmode");
            document.body.classList.remove("lightmode");
        } else {
            document.body.classList.add("lightmode");
            document.body.classList.remove("darkmode");
        }

        const handleDarkMode = () => {
            if (darkmode === "") {
                localStorage.setItem("darkmode", "true");
                document.body.classList.add("darkmode");
            } else if (darkmode === "true") {
                localStorage.setItem("darkmode", "false");
            } else {
                localStorage.setItem("darkmode", "true");
            }
        };

        return (
            <div className="main-header header-sticky guest">
                <Navbar
                    collapseOnSelect
                    expand="lg"
                    className="header-logout-navbar-container"
                >
                    <div className="container">
                        <div className="main-header-container">
                            <div className="header-logo-container">
                                <Link to="/">
                                    <img src={MainLogo} />
                                </Link>
                            </div>
                            <div className="header-menu-container">
                                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                            </div>
                        </div>
                    </div>
                    <Navbar.Collapse
                        id="responsive-navbar-nav"
                        className="header-logout-navbar"
                    >
                        <Nav>
                            <Nav.Link href="/" className="footer-item-link">
                                Home
                            </Nav.Link>
                            <Nav.Link
                                href="/how-it-works"
                                className="footer-item-link"
                            >
                                How It Works
                            </Nav.Link>
                            <Nav.Link
                                href="/referrals"
                                className="footer-item-link"
                            >
                                Referrals
                            </Nav.Link>
                            <Nav.Link
                                href="/terms"
                                className="footer-item-link"
                            >
                                Terms
                            </Nav.Link>
                            <Nav.Link
                                href="/privacy-policy"
                                className="footer-item-link"
                            >
                                Privacy Policy
                            </Nav.Link>
                            <Nav.Link
                                href="/logos"
                                className="footer-item-link"
                            >
                                Logos
                            </Nav.Link>
                            <Nav.Link
                                href="https://priva.uvdesk.com/en/"
                                className="footer-item-link"
                            >
                                Help & FAQs
                            </Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>
            </div>
        );
    }
}
export default Header;
